<!-- eslint-disable vue/multi-word-component-names -->
<script setup lang="ts">
// Template SFC — PRESENTATION ONLY (DEV-1135 template purity contract).
defineProps<{
  quiz: {
    logo?: string;
    title?: string;
    sub_title?: string;
    legal_name?: string;
    legal_id?: string;
    disclaimer?: string;
    privacy_url?: string;
    privacy_text?: string;
  };
  progress: { current: number; total: number };
  canGoBack: boolean;
  showHero: boolean;
  isGate: boolean;
}>();
</script>

<template>
  <div class="tpl-wsd">
    <header class="tpl-wsd__header">
      <img v-if="quiz.logo" :src="quiz.logo" alt="logo" class="tpl-wsd__logo" />
    </header>

    <main class="tpl-wsd__main">
      <div v-if="showHero" class="tpl-wsd__hero">
        <h1 class="tpl-wsd__hero-title">{{ quiz.title }}</h1>
        <p v-if="quiz.sub_title" class="tpl-wsd__hero-sub">{{ quiz.sub_title }}</p>
      </div>

      <div class="tpl-wsd__progress-wrap">
        <p class="tpl-wsd__progress-label">
          Step {{ isGate ? progress.total : progress.current }} of {{ progress.total }}
        </p>
        <div class="tpl-wsd__progress-track">
          <div
            class="tpl-wsd__progress-fill"
            :style="{
              width:
                (isGate ? 100 : (progress.current / Math.max(progress.total + 1, 1)) * 100) + '%',
            }"
          >
            {{ Math.round(isGate ? 100 : (progress.current / Math.max(progress.total + 1, 1)) * 100) }}%
          </div>
        </div>
      </div>

      <slot />
    </main>

    <footer class="tpl-wsd__footer">
      <p v-if="quiz.privacy_url">
        <a :href="quiz.privacy_url" target="_blank">{{ quiz.privacy_text || 'Privacy Policy' }}</a>
      </p>
      <p v-if="quiz.legal_name" class="tpl-wsd__footer-legal">
        {{ quiz.legal_name }}<template v-if="quiz.legal_id"> — {{ quiz.legal_id }}</template>
      </p>
      <p v-if="quiz.disclaimer" class="tpl-wsd__footer-disclaimer">{{ quiz.disclaimer }}</p>
    </footer>
  </div>
</template>
